module.exports = __webpack_public_path__ + "static/media/yakiniku-go.6cdaa1d2.png";